import { ITikTokSettingsAdAccountTtoAccount } from '@services/tiktok';

export type SparkAdsFeaturs = [
  { feature: 'Sending Briefs with Spark Ads', errorMessage: string },
];

export const composeSparkAdsFeatures = (ttoAccount: ITikTokSettingsAdAccountTtoAccount): SparkAdsFeaturs => {
  let errorMessage = '';
  if (!ttoAccount.hasAccess || !ttoAccount.id) {
    errorMessage = 'You must select a TikTok One account that has access to this TikTok Ad Account.';
  } else if (!ttoAccount.verified) {
    errorMessage = 'Your TikTok One account is not verified. Please verify your business for TikTok One and reauthenticate.';
  }

  return [{
    feature: 'Sending Briefs with Spark Ads',
    errorMessage,
}];
};

export type TtoCampaignFeatures = [
  { feature: 'Sending Briefs with Tto Campaign', errorMessage: string },
];

export const composeTtoCampaignFeatures = (hasError: boolean): TtoCampaignFeatures => {
  return [{
    feature: 'Sending Briefs with Tto Campaign',
    errorMessage: hasError ? 'You must verify your business for TikTok One.' : '',
  }];
};
